import { EDUCATIVE_CENTER_CODE_TYPE } from '@/constants/db/companyCodeTypes'
import { SPAIN_COUNTRY_ID } from '@/constants/db/countries'

const availableConstraints = {
  required: function (val) {
    return !!val
  },
  email: function (val) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(val)
  },
  password: function (val) {
    const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.=(){}\-_:,;^`[\]+¨´/¬])[A-Za-z\d@$!%*?&.=(){}\-_:,;^`[\]+¨´/¬]{8,}$/
    return re.test(val)
  },
  phone: function (val) {
    const re = /^\d+$/
    return re.test(val)
  },
  text (val) {
    return /^[ñA-Za-zÀ-ÿ]+$/.test(val)
  },
  textWithWhiteScape (val) {
    return /^[ñA-Za-zÀ-ÿ ]*[ñA-Za-zÀ-ÿ][ñA-Za-zÀ-ÿ ]*$/.test(val)
  },
  question (val) {
    return /^¿?[ñA-Za-zÀ-ÿ ]*[ñA-Za-zÀ-ÿ][ñA-Za-zÀ-ÿ ]*\??$/.test(val)
  },
  number (val) {
    return /^(\d+(?:[\.\,]\d+)?)$/.test(val)
  },
  validTime (val) {
    return /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(val)
  }
}

export function validate (val, constraints, submitted = true) {
	let result = null
	if (submitted) {
		for (const c of constraints) {
			if (!availableConstraints[c](val)) {
				result = false
				break
			}
		}
	} else {
		return null
	}
	return result
}

export function validateUrl (val) {
	return /(https?:\/\/)?([\w\-])+\.{1}([a-zA-Z]{2,63})([\/\w-]*)*\/?\??([^#\n\r]*)?#?([^\n\r]*)/.test(val)
}


export function validateNIF (dni) {
	if (dni == null) {
		return false
	}
	var numero, let2, letra
	var expresionRegularDni = /^[XYZ]?\d{5,8}[A-Z]$/

	dni = dni.toUpperCase()

	if (expresionRegularDni.test(dni) === true) {
			numero = dni.substr(0, dni.length - 1)
			numero = numero.replace('X', 0)
			numero = numero.replace('Y', 1)
			numero = numero.replace('Z', 2)
			let2 = dni.substr(dni.length - 1, 1)
			numero = numero % 23
			letra = 'TRWAGMYFPDXBNJZSQVHLCKET'
			letra = letra.substring(numero, numero + 1)
			if (letra !== let2) {
					return false
			} else {
					return true
			}
	} else {
			return false
	}
}

export function validNIE (nie) {
	// Change the initial letter for the corresponding number and validate as DNI
	var niePrefix = nie.charAt(0)
	switch (niePrefix) {
		case 'X': niePrefix = 0; break
		case 'Y': niePrefix = 1; break
		case 'Z': niePrefix = 2; break
	}
	return this.validateNIF(niePrefix + nie.substr(1))
}

export function validatePersonalId (id, countryId, codeType = null) {
	return !(countryId === SPAIN_COUNTRY_ID || countryId === null) || (id != null && this.validateNIF(id)) || codeType === EDUCATIVE_CENTER_CODE_TYPE
}

export default {
  validate,
  validateUrl,
  validateNIF,
	validNIE,
	validatePersonalId
}



// WEBPACK FOOTER //
// ./src/plugins/validators.js